import React from 'react';
import InvestIcon from './InvestIcon';
import RetireIcon from './RetireIcon';
import CustodialIcon from './CustodialIcon';
import BankCard from './BankCard';
import {
	PERSONAL_BROKERAGE,
	TRADITIONAL_IRA,
	ROTH_IRA,
	CUSTODIAN,
	DEBIT,
} from '../../constants/accountTypes';

const AccountIcon = (props) => {
	const { width, height, accountType } = props;
	switch (accountType) {
		case CUSTODIAN:
			return <CustodialIcon width={width} height={height} />;
		case TRADITIONAL_IRA:
		case ROTH_IRA:
			return <RetireIcon width={width} height={height} />;
		case DEBIT:
			return <BankCard width={width} height={height} />;
		case PERSONAL_BROKERAGE:
		default:
			return <InvestIcon width={width} height={height} />;
	}
};

export default AccountIcon;
